module.exports = __webpack_public_path__ + "static/a-game-of-thrones-5e8113769d9f4961956694b23f66585d.jpg";